<h3>Sign In</h3>
<form (ngSubmit)="onSubmit()" [formGroup]="authForm" class="ui form">
    <app-input 
        inputType="text"
        label="Username"
        [control]="authForm.get('username')"
    ></app-input>
    <app-input
        inputType="password"
        label="Password"
        [control]="authForm.get('password')"
    ></app-input>
    <div *ngIf="authForm.errors" class="ui red basic label">
        <p *ngIf="authForm.errors.credentials">
            Invalid username or password.
        </p>
    </div>
    <div>
        <button class="ui submit button primary">Submit</button>
    </div>
</form>